module.exports = new __parcel__URL__("covid-climate--cover.00dce393.jpg").toString();